import { Component, OnInit, Input, ElementRef, EventEmitter, Output, OnChanges} from '@angular/core';
import { CommonBindingDataService } from './../../services/common-binding-data.service';
import moment from 'moment/src/moment'

@Component({
    selector: 'app-bar-chart',
    templateUrl: './bar-chart.component.html',
    standalone: false
})
export class BarChartComponent implements OnInit, OnChanges {

  colorArray = ['#FF6384', '#36A2EB', '#FFCE56', '#1E88E5', '#9CCC65'];

  @Input() data: any[] = [];
  @Input() header: string;
  @Output() fetchData: EventEmitter<any> = new EventEmitter();
  headerStr = 'Header';
  buildData: any;
  monthList: Array<any> = [];
  selectedMonth;
  yearList: Array<any> = [];
  selectedYear;
  options;
  dateType;
  monthSuggestions: any[] = [];
  yearSuggestions: any[] = [];

  constructor(private elm: ElementRef,
    private commonBindingService: CommonBindingDataService) {
    this.resetData();
    this.setMonthDropDown();
    this.setYearDropDown();
    this.options = {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            stepSize: 10,
            suggestedMax: 50
          }
        }]
      }
    };
  }
  ngOnInit() {
    this.dateType = 'journey';
    this.headerStr = this.header;
    this.refreshData('journey');
  }

  ngOnChanges() {
    this.resetData();
    this.data.forEach(item => {
      this.buildData.labels.push(item.label);
      this.buildData.datasets[0].data.push(item.value);
      this.buildData.datasets[0].backgroundColor.push(this.colorArray[0]);
      this.buildData.datasets[0].hoverBackgroundColor.push(this.colorArray[0]);
      // this.buildData.datasets[1].data.push(item.adaValue);
      // this.buildData.datasets[1].backgroundColor.push(this.colorArray[1]);
      // this.buildData.datasets[1].hoverBackgroundColor.push(this.colorArray[1]);
    });
  }

  resetData() {
    this.buildData = {
      labels: [],
      datasets: [
        {
          label: this.commonBindingService.getLabel('label_total_passengers'),
          data: [],
          backgroundColor: [],
          hoverBackgroundColor: []
        }
        // , {
        //   label: this.commonBindingService.getLabel('label_ada_passengers'),
        //   data: [],
        //   backgroundColor: [],
        //   hoverBackgroundColor: []
        // }
      ]
    };
  }

  getRandomColor() {
    return '#' + Math.random().toString(16).substr(-6);
  }

  setMonthDropDown() {
    this.monthList = [];
    const months = moment.months();
    months.forEach((element, idx) => {
      this.monthList.push({
        label: element,
        value: idx + 1
      });
    });
    const selectedMonth = this.monthList.filter(x => x.value === (moment().month() + 1));
    this.selectedMonth = selectedMonth[0];
  }

  setYearDropDown() {
    this.yearList = [];
    for (let yearCount = 2019; yearCount <= (moment().year() + 10); yearCount++) {
      this.yearList.push({
        label: (yearCount).toString(),
        value: yearCount
      });
    }
    const selectedYear = this.yearList.filter(x => x.value === (moment().year()));
    this.selectedYear = selectedYear[0];
  }

  refreshData(value) {
    this.dateType = value;
    if (this.selectedMonth && this.selectedYear) {
      this.fetchData.emit({
        month: this.selectedMonth.value,
        year: this.selectedYear.value,
        type: value
      });
    }
  }

  filterMonth(event) {
    this.monthSuggestions = [];
    for (let i = 0; i < this.monthList.length; i++) {
      const month = this.monthList[i];
      if (month.label.toLowerCase().includes(event.query.toLowerCase())) {
        this.monthSuggestions.push(month);
      }
    }
  }

  changeMonth(value?) {
    this.selectedMonth = value.value;
    this.refreshData(this.dateType);
  }

  changeYear(value?) {
    this.selectedYear = value.value;
    this.refreshData(this.dateType);
  }

  filterYear(event) {
    this.yearSuggestions = [];
    for (let i = 0; i < this.yearList.length; i++) {
      const year = this.yearList[i];
      if (year.label.toLowerCase().includes(event.query.toLowerCase())) {
        this.yearSuggestions.push(year);
      }
    }
  }

}
